import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";

import {clearDiploma, setDiploma} from "../actions";

import {URL_DIPLOMA_ALUNO} from "../constants";

import PageWrapper from "./shared/pagewrapper/PageWrapper";
import DataGrid from "./shared/datagrid/DataGrid";

import Title from "./Title";

import useFetch from "../hooks/useFetch";
import useErrorMessage from "../hooks/useErrorMessage";

import clsx from "clsx";

import {containedButton, textButton} from "../utils/styles";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {CodeOutlined, DescriptionOutlined, SearchOutlined} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {Paper} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    ...containedButton(theme, true, false),
    ...textButton(theme, false),
    datagridContainer: {
        margin: '0 auto',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 800
        }
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    buttonsWidth: {
        display: 'flex',
        width: 500,
        gap: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
            width: '100%',
            maxWidth: 400
        }
    },
    downloadTypograph: {
        textAlign: 'center'
    }
}));
export default function PageDiploma() {
    const classes = useStyles();

    const dispatch = useDispatch();
    const fetch = useFetch();

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();

    const credencial = searchParams.get("credencial");

    const diploma = useSelector(state => state.diploma);

    const showErrorMessage = useErrorMessage();

    const onClickPesquisarNovamente = () => {
        dispatch(clearDiploma());

        navigate('/');
    }

    const onClickDownloadButton = (url) => {
        window.location.href = url;
    }

    useEffect(() => {
        if (!diploma) {
            if (credencial) {
                fetch(URL_DIPLOMA_ALUNO, {
                    credencial: credencial
                }, fetchedDiploma => {
                    dispatch(setDiploma(fetchedDiploma));
                });
            } else {
                showErrorMessage('Não foi possível realizar a validação do diploma, nenhum código foi encontrado!');
                onClickPesquisarNovamente();
            }
        }
    }, [diploma]);

    return !!diploma && (
        <PageWrapper>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Title />
                    <DataGrid
                        rows={diploma ? [diploma] : []}
                        tableContainerProps={{
                            component: Paper,
                            className: classes.datagridContainer
                        }}
                        responsive
                        comparatorKeys={['hash']}
                        columns={[
                            {
                                label: 'Código de Validação',
                                field: 'hash'
                            },
                            {
                                label: 'Nome',
                                field: 'nome'
                            },
                            {
                                label: 'Curso',
                                field: 'curso'
                            }
                        ]} />
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        className={classes.downloadTypograph}>
                        <strong>Download dos documentos:</strong>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {!!diploma.urlDiplomaPDF && (
                            <Grid item xs={12}>
                                <div className={classes.buttonsContainer}>
                                    <div className={classes.buttonsWidth}>
                                        <Button
                                            variant="contained"
                                            startIcon={<DescriptionOutlined />}
                                            className={clsx(classes.containedButton)}
                                            disabled={!diploma}
                                            fullWidth
                                            onClick={() => {onClickDownloadButton(diploma.urlDiplomaPDF)}}>
                                            Diploma em PDF
                                        </Button>
                                        <Button
                                            variant="contained"
                                            startIcon={<DescriptionOutlined />}
                                            className={clsx(classes.containedButton)}
                                            disabled={!diploma}
                                            fullWidth
                                            onClick={() => {onClickDownloadButton(diploma.urlDiplomaXML)}}>
                                            Diploma em XML
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                        )}
                        {!!diploma.urlHistoricoPDF && (
                            <Grid item xs={12}>
                                <div className={classes.buttonsContainer}>
                                    <div className={classes.buttonsWidth}>
                                        <Button
                                            variant="contained"
                                            startIcon={<DescriptionOutlined />}
                                            className={clsx(classes.containedButton)}
                                            disabled={!diploma}
                                            fullWidth
                                            onClick={() => onClickDownloadButton(diploma.urlHistoricoPDF)}>
                                            Histórico em PDF
                                        </Button>
                                        <Button
                                            variant="contained"
                                            startIcon={<DescriptionOutlined />}
                                            className={clsx(classes.containedButton)}
                                            disabled={!diploma}
                                            fullWidth
                                            onClick={() => onClickDownloadButton(diploma.urlHistoricoXML)}>
                                            Histórico em XML
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                        )}
                        {!!diploma.urlDocumentacaoXML && (
                            <Grid item xs={12}>
                                <div className={classes.buttonsContainer}>
                                    <div className={classes.buttonsWidth}>
                                        <Button
                                            variant="contained"
                                            startIcon={<CodeOutlined />}
                                            className={classes.containedButton}
                                            disabled={!diploma}
                                            fullWidth
                                            onClick={() => {onClickDownloadButton(diploma.urlDocumentacaoXML)}}>
                                            Documentacao Academica em XML
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {!credencial && (
                    <Grid item xs={12}>
                        <div className={classes.buttonsContainer}>
                            <Button
                                startIcon={<SearchOutlined />}
                                className={classes.textButton}
                                fullWidth
                                onClick={onClickPesquisarNovamente}>
                                Pesquisar novamente
                            </Button>
                        </div>
                    </Grid>
                )}
            </Grid>
        </PageWrapper>
    );
};